/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuditLogDtoPage } from '../../models/audit-log-dto-page';
import { LogEventType } from '../../models/log-event-type';

export interface ListAuditLogs$Params {
  userIds?: Array<string>;
  projectIds?: Array<string>;
  logEventTypes?: Array<LogEventType>;
  resourceIds?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'payload' | '-payload' | 'eventType' | '-eventType' | 'user' | '-user' | 'project' | '-project' | 'date' | '-date'>;
}

export function listAuditLogs(http: HttpClient, rootUrl: string, params?: ListAuditLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<AuditLogDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listAuditLogs.PATH, 'get');
  if (params) {
    rb.query('userIds', params.userIds, {});
    rb.query('projectIds', params.projectIds, {});
    rb.query('logEventTypes', params.logEventTypes, {});
    rb.query('resourceIds', params.resourceIds, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuditLogDtoPage>;
    })
  );
}

listAuditLogs.PATH = '/v0/auditLogs';
